import Vue from "vue";

export default {
  users(state, users) {
    state.users.list = users;
  },
  user(state, user) {
    const index = state.users.list.findIndex(u => u._id === user._id);
    if (index >= 0) Vue.set(state.users.list, index, user);
  },
  usersCounter(state, counter) {
    state.users.counter = counter;
  }
};
